var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "monitor-health mb-2" }, [
    _c(
      "div",
      { staticClass: "d-flex align-items-center justify-content-between mb-1" },
      [
        _c("h2", { staticClass: "h4 mb-0" }, [
          _vm._v(" " + _vm._s(_vm.$t("Saúde do pipeline (agora)")) + " "),
        ]),
        _c("small", { staticClass: "text-muted" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.$t(
                  "Ignora o período; respeita o filtro de lojas. As filas são globais."
                )
              ) +
              " "
          ),
        ]),
      ]
    ),
    _c(
      "div",
      { staticClass: "monitor-health__grid" },
      [
        _vm._l(_vm.alertItems, function (item) {
          return _c(
            "button",
            {
              key: item.alert,
              staticClass: "monitor-health__card",
              class: {
                "monitor-health__card--alert": item.count > 0,
                "monitor-health__card--selected":
                  _vm.selectedAlert === item.alert,
              },
              attrs: {
                id: "auto-delivery-monitor_alert-" + item.alert,
                type: "button",
                disabled: !item.count,
                title: item.hint,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit(
                    "select",
                    _vm.selectedAlert === item.alert ? null : item.alert
                  )
                },
              },
            },
            [
              _c("span", { staticClass: "monitor-health__count" }, [
                _vm._v(_vm._s(item.count)),
              ]),
              _c("span", { staticClass: "monitor-health__label" }, [
                _vm._v(_vm._s(item.text)),
              ]),
              item.lastErrorCode
                ? _c("small", { staticClass: "monitor-health__error" }, [
                    _vm._v(" " + _vm._s(item.lastErrorCode) + " "),
                  ])
                : !item.count
                ? _c("small", { staticClass: "text-success" }, [
                    _vm._v(" " + _vm._s(_vm.$t("ok")) + " "),
                  ])
                : _vm._e(),
            ]
          )
        }),
        _vm._l(_vm.queueItems, function (queue) {
          return _c(
            "div",
            {
              key: queue.key,
              staticClass: "monitor-health__card monitor-health__card--queue",
              class: { "monitor-health__card--alert": queue.alert },
            },
            [
              _c("span", { staticClass: "monitor-health__count" }, [
                _vm._v(_vm._s(queue.value)),
              ]),
              _c("span", { staticClass: "monitor-health__label" }, [
                _vm._v(_vm._s(queue.text)),
              ]),
              _c(
                "small",
                { class: queue.alert ? "monitor-health__error" : "text-muted" },
                [_vm._v(_vm._s(queue.detail))]
              ),
            ]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }